import { render, staticRenderFns } from "./ConfidentionalView.vue?vue&type=template&id=1882b854&scoped=true&"
var script = {}
import style0 from "./ConfidentionalView.vue?vue&type=style&index=0&id=1882b854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1882b854",
  null
  
)

export default component.exports